import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'

class Benefit extends ActiveRecord {
  constructor(init) {
    super(init)
    this._display_tier = init.display_tier
    this._tier = init.tier
    this._id = init.id
    this._value = init.value
    this._internal_note = init.internal_note
  }

  static shape = {
    display_tier: PropTypes.string,
    tier: PropTypes.string,
    id: PropTypes.number,
    value: PropTypes.object,
    internal_note: PropTypes.string
  }

  get display_tier() {
    return this._display_tier || ''
  }

  get internal_note() {
    return this._internal_note || ''
  }

  get tier() {
    return this._tier || ''
  }

  get value() {
    return this._value || {}
  }
}

export default Benefit
